import React from "react";

interface TopbarProps {
  onMenuClick?: () => void;
}

const Topbar: React.FC<TopbarProps> = ({ onMenuClick }) => {
  return (
    <header className="bg-white text-gray-900 p-4 flex items-center justify-between shadow-md h-[5.5rem]">
      <div className="flex items-center">
        {/* Hamburger for mobile */}
        <button
          className="md:hidden text-gray-900 text-2xl mr-4"
          onClick={onMenuClick}
        >
          &#9776;
        </button>
        {/* <span className="font-bold text-lg">Admin Dashboard</span> */}
      </div>
      <div>User: Admin</div>
    </header>
  );
};

export default Topbar;
